var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSearchLoop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.81543 11C5.81543 7.691 8.50643 5 11.8154 5C15.1244 5 17.8154 7.691 17.8154 11C17.8154 14.309 15.1244 17 11.8154 17C8.50643 17 5.81543 14.309 5.81543 11ZM21.5224 19.293L18.1274 15.897C19.1804 14.543 19.8154 12.846 19.8154 11C19.8154 6.589 16.2264 3 11.8154 3C7.40443 3 3.81543 6.589 3.81543 11C3.81543 15.411 7.40443 19 11.8154 19C13.6614 19 15.3584 18.365 16.7124 17.312L20.1084 20.707C20.3034 20.902 20.5594 21 20.8154 21C21.0714 21 21.3274 20.902 21.5224 20.707C21.9134 20.316 21.9134 19.684 21.5224 19.293Z",
    fill: "#99ADBA"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchLoop);
export default __webpack_public_path__ + "static/media/SearchLoop.017a389c.svg";
export { ForwardRef as ReactComponent };